import { TimekeeperService } from 'services/TimekeeperService';
const tk = new TimekeeperService();

const gettingZones = async (setLoading, setRows) => {
    setLoading(true);

    tk.zones
        .getZones()
        .then((response) => {
            const rows = response.map((zone) => ({
                id: zone.zone_id,
                name: zone.name,
                description: zone.description,
                type: zone.type,
                requires_approval: zone.requires_approval,
            }));

            setRows(rows);
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
};

const gettingZoneById = async (zone_id) => {
    return await tk.zones.getZoneById(zone_id);
};

const gettingHoliday = async (setLoading, setRows) => {
    setLoading(true);

    tk.holiday
        .getHolidays()
        .then((response) => {
            const rows = response.map((holiday) => ({
                id: holiday.holiday_id,
                name: holiday.name,
            }));

            setRows(rows);
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
};

const gettingOvertime = async (setLoading, setRows) => {
    setLoading(true);

    tk.overtime
        .getOvertimes()
        .then((response) => {
            const rows = response.map((overtime) => ({
                id: overtime.overtime_rule_id,
                name: overtime.name,
            }));

            setRows(rows);
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
};

const addingHolidayZone = async (name, description, type, requires_approval, selected_holidays, defined_by, deducted_time, hours_worked_belong_to) => {
    const body = {
        name,
        description,
        type,
        requires_approval,
        defined_by,
        deducted_time,
        hours_worked_belong_to,
        selected_holidays,
    };
    return tk.zones.createZone(body);
};

const addingWeekdayZone = async (name, description, type, requires_approval, monday, tuesday, wednesday, thursday, friday, saturday, sunday, applies_to) => {
    const days = [monday ? 1 : undefined, tuesday ? 2 : undefined, wednesday ? 4 : undefined, thursday ? 8 : undefined, friday ? 16 : undefined, saturday ? 32 : undefined, sunday ? 64 : undefined]
        .map((day) => day)
        .filter((day) => day !== undefined);

    const body = {
        name,
        description,
        type,
        requires_approval,
        days,
        applies_to,
    };

    return tk.zones.createZone(body);
};

const addingConsecutiveDaysWorkedZone = async (
    name,
    description,
    type,
    requires_approval,
    day_amount,
    min_hours,
    min_hours_last_day,
    type_consecutive,
    reset_to,
    day_number,
    consecutive_days_day_week,
    days_week_restart_day,
    selected_sustitutions,
) => {
    const body = {
        name,
        description,
        type,
        requires_approval,
        day_amount,
        min_hours: min_hours.format('HH:mm'),
        min_hours_last_day: min_hours_last_day.format('HH:mm'),
        type_consecutive,
        consecutive_days_numberday: type_consecutive === 'consecute_days' && reset_to === 'day_number' ? day_number : undefined,
        consecutive_days_day_week: type_consecutive === 'consecute_days' && reset_to === 'days_week' ? consecutive_days_day_week : undefined,
        days_week_restart_day: type_consecutive === 'days_week' ? days_week_restart_day : undefined,
        selected_sustitutions,
    };

    return tk.zones.createZone(body);
};

const addingDifferencialDailyZone = async (
    name,
    description,
    type,
    requires_approval,
    start_hour,
    end_hour,
    min_hours_in_zone,
    min_hours_in_shift,
    margin_early,
    margin_late,
    planned,
    based_by,
    bool_start_work_before,
    bool_start_work_after,
    bool_end_work_before,
    bool_end_work_after,
    start_work_before,
    start_work_after,
    end_work_before,
    end_work_after,
) => {
    const body = {
        name,
        description,
        type,
        requires_approval,
        start_hour: start_hour.format('HH:mm'),
        end_hour: end_hour.format('HH:mm'),
        min_hours_in_zone: min_hours_in_zone.format('HH:mm'),
        min_hours_in_shift: min_hours_in_shift.format('HH:mm'),
        margin_early: margin_early.format('HH:mm'),
        margin_late: margin_late.format('HH:mm'),
        planned: planned,
        based_by: bool_start_work_before || bool_end_work_before || bool_start_work_after || bool_end_work_after ? based_by : undefined,
        start_work_before: bool_start_work_before ? start_work_before.format('HH:mm') : undefined,
        start_work_after: bool_start_work_after ? start_work_after.format('HH:mm') : undefined,
        end_work_before: bool_end_work_before ? end_work_before.format('HH:mm') : undefined,
        end_work_after: bool_end_work_after ? end_work_after.format('HH:mm') : undefined,
    };
    return tk.zones.createZone(body);
};

const addingDifferencialWeekendlyZone = async (
    name,
    description,
    type,
    requires_approval,
    start_hour,
    end_hour,
    min_hours_in_zone,
    min_hours_in_shift,
    margin_early,
    margin_late,
    planned,
    based_by,
    bool_start_work_before,
    bool_start_work_after,
    bool_end_work_before,
    bool_end_work_after,
    start_work_before,
    start_work_after,
    end_work_before,
    end_work_after,
    start_day,
    end_day,
) => {
    const body = {
        name,
        description,
        type,
        requires_approval,
        start_hour: start_hour.format('HH:mm'),
        end_hour: end_hour.format('HH:mm'),
        min_hours_in_zone: min_hours_in_zone.format('HH:mm'),
        min_hours_in_shift: min_hours_in_shift.format('HH:mm'),
        margin_early: margin_early.format('HH:mm'),
        margin_late: margin_late.format('HH:mm'),
        planned: planned,
        based_by: bool_start_work_before || bool_end_work_before || bool_start_work_after || bool_end_work_after ? based_by : undefined,
        start_work_before: bool_start_work_before ? start_work_before.format('HH:mm') : undefined,
        start_work_after: bool_start_work_after ? start_work_after.format('HH:mm') : undefined,
        end_work_before: bool_end_work_before ? end_work_before.format('HH:mm') : undefined,
        end_work_after: bool_end_work_after ? end_work_after.format('HH:mm') : undefined,
        start_day,
        end_day,
    };

    return tk.zones.createZone(body);
};

const deletingZone = async (zoneId) => {
    return tk.zones.deleteZone(zoneId);
};

const updatingHolidayZone = async (zone_id, name, description, type, requires_approval, selected_holidays, defined_by, deducted_time, hours_worked_belong_to) => {
    const body = {
        zone_id,
        name,
        description,
        type,
        requires_approval,
        defined_by,
        deducted_time,
        hours_worked_belong_to,
        selected_holidays,
    };

    return tk.zones.updateZone(zone_id, body);
};

const updatingWeekdayZone = async (zone_id, name, description, type, requires_approval, monday, tuesday, wednesday, thursday, friday, saturday, sunday, applies_to) => {
    const days = [monday ? 1 : undefined, tuesday ? 2 : undefined, wednesday ? 4 : undefined, thursday ? 8 : undefined, friday ? 16 : undefined, saturday ? 32 : undefined, sunday ? 64 : undefined]
        .map((day) => day)
        .filter((day) => day !== undefined);

    const body = {
        zone_id,
        name,
        description,
        type,
        requires_approval,
        days,
        applies_to,
    };

    return tk.zones.updateZone(zone_id, body);
};

const updatingConsecutiveDaysWorkedZone = async (
    zone_id,
    name,
    description,
    type,
    requires_approval,
    day_amount,
    min_hours,
    min_hours_last_day,
    type_consecutive,
    reset_to,
    day_number,
    consecutive_days_day_week,
    days_week_restart_day,
    selected_sustitutions,
) => {
    const body = {
        zone_id,
        name,
        description,
        type,
        requires_approval,
        day_amount,
        min_hours: min_hours.format('HH:mm'),
        min_hours_last_day: min_hours_last_day.format('HH:mm'),
        type_consecutive,
        consecutive_days_numberday: type_consecutive === 'consecute_days' && reset_to === 'day_number' ? day_number : undefined,
        consecutive_days_day_week: type_consecutive === 'consecute_days' && reset_to === 'days_week' ? consecutive_days_day_week : undefined,
        days_week_restart_day: type_consecutive === 'days_week' ? days_week_restart_day : undefined,
        selected_sustitutions,
    };

    return tk.zones.updateZone(zone_id, body);
};

const updatingDifferencialDailyZone = async (
    zone_id,
    name,
    description,
    type,
    requires_approval,
    start_hour,
    end_hour,
    min_hours_in_zone,
    min_hours_in_shift,
    margin_early,
    margin_late,
    planned,
    based_by,
    bool_start_work_before,
    bool_start_work_after,
    bool_end_work_before,
    bool_end_work_after,
    start_work_before,
    start_work_after,
    end_work_before,
    end_work_after,
) => {
    const body = {
        zone_id,
        name,
        description,
        type,
        requires_approval,
        start_hour: start_hour.format('HH:mm'),
        end_hour: end_hour.format('HH:mm'),
        min_hours_in_zone: min_hours_in_zone.format('HH:mm'),
        min_hours_in_shift: min_hours_in_shift.format('HH:mm'),
        margin_early: margin_early.format('HH:mm'),
        margin_late: margin_late.format('HH:mm'),
        planned: planned,
        based_by: bool_start_work_before || bool_end_work_before || bool_start_work_after || bool_end_work_after ? based_by : undefined,
        start_work_before: bool_start_work_before ? start_work_before.format('HH:mm') : undefined,
        start_work_after: bool_start_work_after ? start_work_after.format('HH:mm') : undefined,
        end_work_before: bool_end_work_before ? end_work_before.format('HH:mm') : undefined,
        end_work_after: bool_end_work_after ? end_work_after.format('HH:mm') : undefined,
    };

    return tk.zones.updateZone(zone_id, body);
};

const updatingDifferencialWeekendlyZone = async (
    zone_id,
    name,
    description,
    type,
    requires_approval,
    start_hour,
    end_hour,
    min_hours_in_zone,
    min_hours_in_shift,
    margin_early,
    margin_late,
    planned,
    based_by,
    bool_start_work_before,
    bool_start_work_after,
    bool_end_work_before,
    bool_end_work_after,
    start_work_before,
    start_work_after,
    end_work_before,
    end_work_after,
    start_day,
    end_day,
) => {
    const body = {
        zone_id,
        name,
        description,
        type,
        requires_approval,
        start_hour: start_hour.format('HH:mm'),
        end_hour: end_hour.format('HH:mm'),
        min_hours_in_zone: min_hours_in_zone.format('HH:mm'),
        min_hours_in_shift: min_hours_in_shift.format('HH:mm'),
        margin_early: margin_early.format('HH:mm'),
        margin_late: margin_late.format('HH:mm'),
        planned: planned,
        based_by: bool_start_work_before || bool_end_work_before || bool_start_work_after || bool_end_work_after ? based_by : undefined,
        start_work_before: bool_start_work_before ? start_work_before.format('HH:mm') : undefined,
        start_work_after: bool_start_work_after ? start_work_after.format('HH:mm') : undefined,
        end_work_before: bool_end_work_before ? end_work_before.format('HH:mm') : undefined,
        end_work_after: bool_end_work_after ? end_work_after.format('HH:mm') : undefined,
        start_day,
        end_day,
    };

    return tk.zones.updateZone(zone_id, body);
};

export {
    gettingZones,
    gettingZoneById,
    gettingHoliday,
    gettingOvertime,
    addingHolidayZone,
    addingWeekdayZone,
    addingConsecutiveDaysWorkedZone,
    addingDifferencialDailyZone,
    addingDifferencialWeekendlyZone,
    updatingHolidayZone,
    updatingWeekdayZone,
    updatingConsecutiveDaysWorkedZone,
    updatingDifferencialDailyZone,
    updatingDifferencialWeekendlyZone,
    deletingZone,
};
